import type { Control, UseFormHandleSubmit } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { InputControlled } from '@/components/form/input-controlled';
import { Button } from '@/components/ui/button';
import type {
  CreateLotSizingLine,
  CreateLotSizingLineInput,
} from '@/features/lot-sizing/schema/lot-sizing-add-line-schema';

type LotSizingAddLineFormProps = {
  control: Control<CreateLotSizingLineInput, unknown, CreateLotSizingLine>;
  handleSubmit: UseFormHandleSubmit<CreateLotSizingLine>;
  onSubmit: (data: CreateLotSizingLine) => void | Promise<void>;
  children?: React.ReactNode;
  isSubmitting?: boolean;
};

export function LotSizingAddLineForm({
  control,
  handleSubmit,
  onSubmit,
  children,
  isSubmitting = false,
}: LotSizingAddLineFormProps) {
  const { t } = useTranslation('lotSizing');

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <InputControlled
        control={control}
        id='productId'
        label={t('productId')}
        name='productId'
        ns='lotSizing'
        placeholder={t('Enter a ProductId')}
        type='text'
      />
      <div className='flex justify-end gap-2'>
        {children}
        <Button disabled={isSubmitting} type='submit'>
          {t('Add to lot sizing')}
        </Button>
      </div>
    </form>
  );
}
